// PrimaryButton.jsx - Primary green CTA button matching Figma design
import React from 'react';

const PrimaryButton = ({
  children,
  type = 'button',
  onClick,
  disabled = false,
  loading = false,
  className = '',
  ...props
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      aria-busy={loading}
      className={`w-full py-3 px-5 rounded-[4px] bg-bloom-green text-[#f0f5f2] font-['Helvetica_Neue'] font-medium text-[16px] leading-[1.5] transition-all relative overflow-hidden group ${
        disabled || loading
          ? 'opacity-50 cursor-not-allowed'
          : 'hover:shadow-lg hover:shadow-green-500/20 hover:bg-bloom-green-hover'
      } ${className}`}
      {...props}
    >
      {/* Shimmer effect on hover */}
      {!disabled && !loading && (
        <span className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-green-400/30 to-transparent -translate-x-full group-hover:animate-shimmer"></span>
      )}

      {/* Loading spinner */}
      {loading && (
        <span className="absolute inset-0 flex items-center justify-center">
          <div className="animate-spin h-5 w-5 border-2 border-[#f0f5f2] rounded-full border-t-transparent"></div>
        </span>
      )}

      {/* Button text */}
      <span className={loading ? 'opacity-0' : ''}>{children}</span>
    </button>
  );
};

export default PrimaryButton;
